import {
  ANNOTATION_CHANGED_EVENT,
  ANNOTATIONS_LOADED_EVENT,
  ANNOTATION_SELECTED_EVENT,
  DOCUMENT_LOADED_EVENT,
  PAGE_COMPLETE_EVENT,
  TEXT_SELECTED_EVENT,
} from '../constants/pdf-annotations'

class PDFTronAnnotationsListener {
  constructor(pdfTronInstance, pdfAnnotationsManager) {
    const { annotationManager, documentViewer } = pdfTronInstance.Core

    this.annotationManager = annotationManager
    this.documentViewer = documentViewer

    this.pdfAnnotationsManager = pdfAnnotationsManager
    this.fetchAnnotations = this.pdfAnnotationsManager.fetchAnnotations

    this.namespace = 'silverfin'
  }

  setup() {
    this.pdfAnnotationsManager.setup()
    this._setupAnnotationsEventListeners()
    this._setupEventHubListeners()
  }

  cleanup() {
    this.documentViewer.removeEventListener(`.${this.namespace}`)
    this.annotationManager.removeEventListener(`.${this.namespace}`)

    window.eventHub.$off(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.fetchAnnotations
    )
    window.eventHub.$off(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.handleDeletedAnnotation
    )
    window.eventHub.$off(
      'selectPdfAnnotation',
      this.pdfAnnotationsManager.ensureFocusAnnotation
    )
    window.eventHub.$off(
      'clearAnchor',
      this.pdfAnnotationsManager.deselectAllAnnotations
    )
    window.eventHub.$off(
      'modal-closed',
      this.pdfAnnotationsManager.handleRemarkModalClosed
    )
  }

  _setupEventHubListeners() {
    window.eventHub.$on(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.fetchAnnotations
    )
    window.eventHub.$on(
      'refreshCommunicationData',
      this.pdfAnnotationsManager.handleDeletedAnnotation
    )
    window.eventHub.$on(
      'selectPdfAnnotation',
      this.pdfAnnotationsManager.ensureFocusAnnotation
    )
    window.eventHub.$on(
      'clearAnchor',
      this.pdfAnnotationsManager.deselectAllAnnotations
    )
    window.eventHub.$on(
      'modal-closed',
      this.pdfAnnotationsManager.handleRemarkModalClosed
    )
  }

  _setupAnnotationsEventListeners() {
    this.documentViewer.addEventListener(
      this._namespacedEvent(ANNOTATIONS_LOADED_EVENT),
      () => {
        this.pdfAnnotationsManager.handleAnnotationsLoaded()
      }
    )

    this.documentViewer.addEventListener(
      this._namespacedEvent(TEXT_SELECTED_EVENT),
      (quads, _text, pageNumber) => {
        this.pdfAnnotationsManager.handleTextSelected({ quads, pageNumber })
      }
    )

    this.documentViewer.addEventListener(
      this._namespacedEvent(DOCUMENT_LOADED_EVENT),
      () => {
        this.pdfAnnotationsManager.handleDocumentLoaded()
      }
    )

    this.documentViewer.addEventListener(
      this._namespacedEvent(PAGE_COMPLETE_EVENT),
      (pageNumber, canvas) => {
        this.pdfAnnotationsManager.handlePageComplete(pageNumber, canvas)
      }
    )

    this.annotationManager.addEventListener(
      this._namespacedEvent(ANNOTATION_CHANGED_EVENT),
      async (annotations, action, { imported }) => {
        await this.pdfAnnotationsManager.handleAnnotationChanged({
          annotations,
          action,
          imported,
        })
      }
    )

    this.annotationManager.addEventListener(
      this._namespacedEvent(ANNOTATION_SELECTED_EVENT),
      (annotations, action) => {
        this.pdfAnnotationsManager.handleAnnotationSelected({
          annotations,
          action,
        })
      }
    )
  }

  _namespacedEvent(event) {
    return `${event}.${this.namespace}`
  }
}

export default PDFTronAnnotationsListener
